export default __webpack_public_path__ + "static/media/studentCoins.bec5bbe2.png";